/* Opportunity report chart metrics + PDF KPI / wheel banners */
import {refData} from "@/utils/ref-data.js";
import Chart from "chart.js";
import "chartjs-plugin-labels";
import {
	faChartLine,
	faTrophy,
	faCalculator,
	faStar,
	faCalendarAlt,
	faPaperPlane,
	faChartPie,
	faTags,
	faCity,
	faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";

const WHEEL_COLORS = ['#4fa4ff', '#5dade2', '#41b8d5', '#9b59b6', '#f5b6c8', '#e74c3c', '#27ae60','#f5a623','#1e8449','#7f77dd','#33adff','#2d8bba','#2f5f98','#31356e','#4076ba','#41b8d5','#6ce5e8','#004f98',
				      '#4682b4','#5072a7','#b0c4de','#6082b6','#417dc1','#483d8b','#99badd','#ff5500','#00bfff','#126180','#5b92e5','#a2add0','#a2a2d0','#92a1cf','#778ba5','#1f75fe',
				      '#ff002a'
					];

const CHART_OPTIONS = [
	{value: "totalPipelineValueKPI", text: "Total Pipeline Value"},
	{value: "hitRateKPI", text: "Hit Rate"},
	{value: "wonThisMonthKPI", text: "Won this Month"},
	{value: "wonThisQuarterKPI", text: "Won this Quartr"},
	{value: "highOpportunityDealsKPI", text: "High Probability Deal"},
	{value: "dueThisWeekKPI", text: "Due This Week"},
	{value: "dueThisMonthKPI", text: "Due This Month"},
	{value: "submittedWaitingResponseKPI", text: "Submitted Waiting Response"},
	{value: "marketSegmentChart", text: "Pipeline By Market Segment"},
	{value: "categoryChart", text: "Pipeline By Category"},
	{value: "statusChart", text: "Pipeline By Status"},
	{value: "cityChart", text: "Pipeline By City"},
];

const CHART_META = {
	totalPipelineValueKPI: {
		label: "Total Pipeline Value",
		iconBg: [79, 164, 255],
		icon: faChartLine,
		type: "kpi",
		table:"Opportunities"
	},
	hitRateKPI: {
		label: "Hit Rate",
		iconBg: [245, 166, 35],
		icon: faCalculator,
		type: "kpi",
		table:"Opportunities"
	},
   wonThisMonthKPI: {
		label: "Won this Month",
		iconBg: [155, 89, 182],
		icon: faTrophy,
		type: "kpi",
		table:"Opportunities"
	},	
	wonThisQuarterKPI: {
		label: "Won this Quarter",
		iconBg: [155, 89, 182],
		icon: faTrophy,
		type: "kpi",
		table:"Opportnities"
	},
	highOpportunityDealsKPI: {
		label: "High Probability Deal",
		iconBg: [65, 184, 213],
		icon: faStar,
		type: "kpi",
		table:"Opportunities"
	},
	dueThisWeekKPI: {
		label: "Due This Week",
		iconBg: [39, 174, 96],
		icon: faCalendarAlt,
		type: "kpi",
		table:"Opportunities"
	},	
	dueThisMonthKPI: {
		label: "Due This Month",
		iconBg: [39, 174, 96],
		icon: faCalendarAlt,
		type: "kpi",
		table:"Opportunities"
	},
	submittedWaitingResponseKPI: {
		label: "Submitted Waiting Response",
		iconBg: [52, 152, 219],
		icon: faPaperPlane,
		type: "kpi",
		table:"Opportunities"
	},
	marketSegmentChart: {
		label: "Pipeline By Market Segment",
		iconBg: [79, 164, 255],
		icon: faChartPie,
		type: "wheel",
		groupField: "marketSegmentId",
		refKey: "marketSegments",
		mode: "count",
		table:"Opportunities"
	},
	categoryChart: {
		label: "Pipeline By Category",
		iconBg: [155, 89, 182],
		icon: faTags,
		type: "wheel",
		groupField: "categoryId",
		refKey: "categories",
		mode: "count",
		table:"Opportunities"
	},
	cityChart: {
		label: "Pipeline By City",
		iconBg: [65, 184, 213],
		icon: faCity,
		type: "wheel",
		groupField: "city",
		mode: "value",
		table:"Opportunities"
	},
		statusChart: {
		label: "Pipeline By Status",
		iconBg: [46, 204, 113],
		icon: faClipboardCheck,
		type: "wheel",
		groupField: "opportunityStatusId",
		refKey:"opportunityStatuses",
		mode: "count",
		table:"Opportunities"
	},
};

/** Normalize saved chart field(s) to an array of chart keys. */
function fn_normalizeReportCharts(reportCharts, legacyReportChart) {
	var keys = [];
	if (Array.isArray(reportCharts)) {
		keys = reportCharts.slice();
	} else if (typeof reportCharts === "string" && reportCharts) {
		keys = [reportCharts];
	} else if (typeof legacyReportChart === "string" && legacyReportChart) {
		keys = [legacyReportChart];
	}
	return keys.filter(function(k) { return k && CHART_META[k]; });
}

function fn_fmtCurrency(val) {
	if (val >= 1000000) return "$" + (val / 1000000).toFixed(2) + "M";
	if (val >= 1000) return "$" + Math.round(val / 1000).toLocaleString() + "K";
	return "$" + Math.round(val || 0).toLocaleString();
}

function fn_statusName(row) {
	if (row.opportunityStatusName) return row.opportunityStatusName;
	var id = row.opportunityStatusId;
	if (id == null) return "";
	var statuses = refData.opportunityStatuses || [];
	var match = statuses.find(function(s) { return s.id == id; });
	return match ? match.name : "";
}

function fn_rowYear(row) {
	var dateStr = row.securedDate || row.updatedUTC || row.createdUTC;
	if (!dateStr) return null;
	var d = new Date(dateStr);
	return isNaN(d.getTime()) ? null : d.getFullYear();
}

function fn_refName(refKey, id) {
	if (id == null || id === "") return "Other";
	var list = (refData && refData[refKey]) || [];
	var match = list.find(function(r) { return r.id == id; });
	return match ? (match.name || match.text || String(id)) : String(id);
}

function fn_calcTotalPipelineValue(rows) {
	return (rows || []).reduce(function(sum, r) {
		return sum + (Number(r.value) || 0);
	}, 0);
}

function fn_calcHitRate(rows) {
	var year = new Date().getFullYear();
	var secured = 0;
	var lost = 0;
	(rows || []).forEach(function(r) {
		var status = fn_statusName(r);
		var rowYear = fn_rowYear(r);
		if (rowYear !== year) return;
		if (status === "Secured") secured++;
		else if (status === "Not Awarded") lost++;
	});
	var closed = secured + lost;
	return closed > 0 ? Math.round((secured / closed) * 100) : 0;
}

function fn_calcWonThisMonth(rows) {
	var now = new Date();
	return (rows || []).reduce(function(sum, r) {
		if (fn_statusName(r) !== "Secured" || !r.securedDate) return sum;
		var d = new Date(r.securedDate);
		if (isNaN(d.getTime())) return sum;
		if (d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear()) {
			return sum + (Number(r.value) || 0);
		}
		return sum;
	}, 0);
}

function fn_calcWonThisQuarter(rows) {
	var now = new Date();
	var currentQuarter = Math.floor(now.getMonth() / 3);

	return (rows || []).reduce(function(sum, r) {
		if (fn_statusName(r) !== "Secured" || !r.securedDate) return sum;

		var d = new Date(r.securedDate);
		if (isNaN(d.getTime())) return sum;

		var rowQuarter = Math.floor(d.getMonth() / 3);

		if (
			rowQuarter === currentQuarter &&
			d.getFullYear() === now.getFullYear()
		) {
			return sum + (Number(r.value) || 0);
		}

		return sum;
	}, 0);
}

function fn_calcHighOpportunityDeals(rows) {
	return (rows || []).filter(function(r) {
		return Number(r.winProbability) > 60;
	}).length;
}
function fn_calcDueThisWeek(rows) {
	var now = new Date();

	var startOfWeek = new Date(now);
	startOfWeek.setHours(0, 0, 0, 0);

	var day = now.getDay(); // 0 = Sunday, 1 = Monday, ...
	var diff = day === 0 ? -6 : 1 - day;

	startOfWeek.setDate(now.getDate() + diff);

	var endOfWeek = new Date(startOfWeek);
	endOfWeek.setDate(startOfWeek.getDate() + 6);
	endOfWeek.setHours(23, 59, 59, 999);

	return (rows || []).filter(function(r) {
		if (!r.dueDate) return false;

		var d = new Date(r.dueDate);
		if (isNaN(d.getTime())) return false;

		return d >= startOfWeek && d <= endOfWeek;
	}).length;
}
function fn_calcDueThisMonth(rows) {
	var now = new Date();
	return (rows || []).filter(function(r) {
		if (!r.dueDate) return false;
		var d = new Date(r.dueDate);
		if (isNaN(d.getTime())) return false;
		return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
	}).length;
}

function fn_calcSubmittedWaitingResponse(rows) {
	return (rows || []).filter(function(r) {
		return fn_statusName(r) === "Submitted";
	}).length;
}

function fn_buildWheelSlices(chartKey, rows) {
	var meta = CHART_META[chartKey];
	if (!meta || meta.type !== "wheel") return [];
	var buckets = {};
	(rows || []).forEach(function(r) {
		var label;
		if (meta.refKey) {
			label = fn_refName(meta.refKey, r[meta.groupField]);
		} else {
			label = (r[meta.groupField] && String(r[meta.groupField]).trim()) || "Unknown";
		}
		if (!buckets[label]) buckets[label] = 0;
		if (meta.mode === "value") {
			buckets[label] += Number(r.value) || 0;
		} else {
			buckets[label] += 1;
		}
	});
	var entries = Object.keys(buckets).map(function(label) {
		return {label: label, value: buckets[label]};
	}).filter(function(e) { return e.value > 0; });
	entries.sort(function(a, b) { return b.value - a.value; });
	var total = entries.reduce(function(s, e) { return s + e.value; }, 0) || 1;
	return entries.map(function(e, ix) {
		return {
			label: e.label,
			value: e.value,
			pct: Math.round((e.value / total) * 100),
			color: WHEEL_COLORS[ix % WHEEL_COLORS.length],
			display: meta.mode === "value" ? fn_fmtCurrency(e.value) : String(e.value),
		};
	});
}

function fn_buildReportChartMetric(chartKey, rows) {
	if (!chartKey || !CHART_META[chartKey]) return null;
	var meta = CHART_META[chartKey];
	if (meta.type === "wheel") {
		return {
			key: chartKey,
			label: meta.label,
			type: "wheel",
			iconBg: meta.iconBg,
			icon: meta.icon,
			slices: fn_buildWheelSlices(chartKey, rows),
		};
	}
	var value;
	switch (chartKey) {
		case "totalPipelineValueKPI":
			value = fn_fmtCurrency(fn_calcTotalPipelineValue(rows));
			break;
		case "hitRateKPI":
			value = fn_calcHitRate(rows) + "%";
			break;
		case "wonThisMonthKPI":
			value = fn_fmtCurrency(fn_calcWonThisMonth(rows));
			break;
		case "wonThisQuarterKPI":
			value = fn_fmtCurrency(fn_calcWonThisQuarter(rows));
			break;
		case "highOpportunityDealsKPI":
			value = String(fn_calcHighOpportunityDeals(rows));
			break;
		case "dueThisMonthKPI":
			value = String(fn_calcDueThisMonth(rows));
			break;
		case "dueThisWeekKPI":
			value = String(fn_calcDueThisWeek(rows));
			break;
		case "submittedWaitingResponseKPI":
			value = String(fn_calcSubmittedWaitingResponse(rows));
			break;
		default:
			return null;
	}
	return {
		key: chartKey,
		label: meta.label,
		value: value,
		type: "kpi",
		iconBg: meta.iconBg,
		icon: meta.icon,
	};
}

/** Render a Font Awesome icon definition to a PNG data URL (sync, via canvas). */
function fn_faIconDataUrl(iconDef, sizePx, fillColor) {
	if (!iconDef || !iconDef.icon || typeof document === "undefined") return null;
	try {
		var width = iconDef.icon[0];
		var height = iconDef.icon[1];
		var pathData = iconDef.icon[4];
		var paths = Array.isArray(pathData) ? pathData : [pathData];
		var scale = 3;
		var canvas = document.createElement("canvas");
		canvas.width = sizePx * scale;
		canvas.height = sizePx * scale;
		var ctx = canvas.getContext("2d");
		if (!ctx || typeof Path2D === "undefined") return null;
		ctx.clearRect(0, 0, canvas.width, canvas.height);
		ctx.fillStyle = fillColor || "#ffffff";
		var s = Math.min(canvas.width / width, canvas.height / height) * 0.62;
		var ox = (canvas.width - width * s) / 2;
		var oy = (canvas.height - height * s) / 2;
		ctx.translate(ox, oy);
		ctx.scale(s, s);
		paths.forEach(function(p) {
			if (!p) return;
			ctx.fill(new Path2D(p));
		});
		return canvas.toDataURL("image/png");
	} catch (e) {
		console.warn("PDF chart icon render failed", e);
		return null;
	}
}

function fn_renderWheelDataUrl(slices, sizePx, showPercentOnSlices) {
	if (typeof document === "undefined" || !slices || !slices.length) return null;
	try {
		// Extra padding so outside % labels are not clipped
		var pad = showPercentOnSlices ? 36 : 0;
		var canvas = document.createElement("canvas");
		canvas.width = sizePx + pad * 2;
		canvas.height = sizePx + pad * 2;
		var chart = new Chart(canvas.getContext("2d"), {
			type: "doughnut",
			data: {
				labels: slices.map(function(s) { return s.label; }),
				datasets: [{
					data: slices.map(function(s) { return s.value; }),
					backgroundColor: slices.map(function(s) { return s.color; }),
					borderWidth: 2,
					borderColor: "#fff",
				}],
			},
			options: {
				responsive: false,
				animation: false,
				maintainAspectRatio: true,
				cutoutPercentage: 65,
				legend: {display: false},
				tooltips: {enabled: false},
				layout: {
					padding: showPercentOnSlices ? 18 : 0,
				},
				plugins: {
					labels: showPercentOnSlices ? {
						render: "percentage",
						precision: 0,
						showZero: false,
						fontSize: 11,
						fontColor: "#fff",
						fontStyle: "bold",
						position: "border",
						overlap: false,
						textShadow: true,
						shadowColor: "rgba(0,0,0,0.35)",
					} : {render: function() { return ""; }},
					datalabels: {
						display: false,
					},
				},
			},
		});
		var dataUrl = chart.toBase64Image();
		chart.destroy();
		return dataUrl;
	} catch (e) {
		console.warn("PDF wheel chart render failed", e);
		return null;
	}
}

function fn_drawSingleKpiCard(pdfDoc, metric, x, y, cardW, cardH) {
	var iconSize = 30;
	var pad = 8;

	pdfDoc.setFillColor(255, 255, 255);
	pdfDoc.roundedRect(x, y, cardW, cardH, 4, 4, "F");

	var iconX = x + pad;
	var iconY = y + (cardH - iconSize) / 2;
	pdfDoc.setFillColor(metric.iconBg[0], metric.iconBg[1], metric.iconBg[2]);
	pdfDoc.roundedRect(iconX, iconY, iconSize, iconSize, 4, 4, "F");

	if (metric.icon) {
		var dataUrl = fn_faIconDataUrl(metric.icon, iconSize, "#ffffff");
		if (dataUrl) {
			try {
				pdfDoc.addImage(dataUrl, "PNG", iconX, iconY, iconSize, iconSize);
			} catch (e) {
				console.warn("PDF chart icon addImage failed", e);
			}
		}
	}

	var textX = iconX + iconSize + 10;
	pdfDoc.setTextColor(108, 117, 125);
	pdfDoc.setFont("helvetica", "normal");
	pdfDoc.setFontSize(8);
	pdfDoc.text(metric.label, textX, y + 18);

	pdfDoc.setTextColor(33, 37, 41);
	pdfDoc.setFont("helvetica", "bold");
	pdfDoc.setFontSize(14);
	pdfDoc.text(String(metric.value), textX, y + 38);
}

function fn_drawWheelCard(pdfDoc, metric, x, y, cardW, cardH) {
	pdfDoc.setFillColor(255, 255, 255);
	pdfDoc.roundedRect(x, y, cardW, cardH, 4, 4, "F");

	pdfDoc.setTextColor(73, 80, 87);
	pdfDoc.setFont("helvetica", "bold");
	pdfDoc.setFontSize(9);
	pdfDoc.text(metric.label, x + 10, y + 14);

	var slices = metric.slices || [];
	if (!slices.length) {
		pdfDoc.setFont("helvetica", "normal");
		pdfDoc.setFontSize(8);
		pdfDoc.setTextColor(173, 181, 189);
		pdfDoc.text("No data", x + 10, y + 40);
		return;
	}

	var donutSize = Math.min(90, cardH - 28);
	//var showPctOnSlices = metric.key === "cityChart" || metric.key === "marketSegmentChart" || metric.key === "category";
	var showPctOnSlices = ["cityChart","marketSegmentChart","categoryChart","statusChart"].includes(metric.key);
	var dataUrl = fn_renderWheelDataUrl(slices, 180, showPctOnSlices);
	if (dataUrl) {
		try {
			pdfDoc.addImage(dataUrl, "PNG", x + 8, y + 20, donutSize, donutSize);
		} catch (e) {
			console.warn("PDF wheel addImage failed", e);
		}
	}

	var legendX = x + donutSize + 18;
	var legendY = y + 28;
	var maxLegend = Math.min(slices.length, 6);
	for (var i = 0; i < maxLegend; i++) {
		var s = slices[i];
		var rgb = fn_hexToRgb(s.color);
		pdfDoc.setFillColor(rgb[0], rgb[1], rgb[2]);
		pdfDoc.roundedRect(legendX, legendY - 6, 8, 8, 1, 1, "F");
		pdfDoc.setFont("helvetica", "normal");
		pdfDoc.setFontSize(7);
		pdfDoc.setTextColor(73, 80, 87);
		var legendText = metric.key === "pipelineByCity"
			? (s.label + " " + s.pct + "%")
			: (s.label + " (" + s.display + ")");
		var clipped = pdfDoc.splitTextToSize(legendText, cardW - (legendX - x) - 12)[0];
		pdfDoc.text(clipped, legendX + 12, legendY);
		legendY += 12;
	}
	if (slices.length > maxLegend) {
		pdfDoc.setTextColor(173, 181, 189);
		pdfDoc.text("+" + (slices.length - maxLegend) + " more", legendX + 12, legendY);
	}
}

function fn_hexToRgb(hex) {
	var h = String(hex || "").replace("#", "");
	if (h.length !== 6) return [79, 164, 255];
	return [
		parseInt(h.slice(0, 2), 16),
		parseInt(h.slice(2, 4), 16),
		parseInt(h.slice(4, 6), 16),
	];
}

/**
 * Draw selected report charts on the PDF.
 * Returns the Y position below the banners for subsequent content.
 */
function fn_drawReportChart(pdfDoc, chartKeysOrReport, rows, startY) {
	if (!pdfDoc) return startY || 50;

	var keys = [];
	if (Array.isArray(chartKeysOrReport)) {
		keys = fn_normalizeReportCharts(chartKeysOrReport);
	} else if (chartKeysOrReport && typeof chartKeysOrReport === "object") {
		keys = fn_normalizeReportCharts(chartKeysOrReport.reportCharts, chartKeysOrReport.reportChart);
	} else {
		keys = fn_normalizeReportCharts(chartKeysOrReport);
	}

	var metrics = keys.map(function(k) {
		return fn_buildReportChartMetric(k, rows);
	}).filter(Boolean);

	if (!metrics.length) return startY || 50;

	var kpiMetrics = metrics.filter(function(m) { return m.type !== "wheel"; });
	var wheelMetrics = metrics.filter(function(m) { return m.type === "wheel"; });

	var startX = 20;
	var pageWidth = (pdfDoc.internal && pdfDoc.internal.pageSize && pdfDoc.internal.pageSize.getWidth)
		? pdfDoc.internal.pageSize.getWidth()
		: 842;
	var availW = pageWidth - 40;
	var gap = 10;
	var rowY = (typeof startY === "number" ? startY : 55);
	var maxX = pageWidth - 20;

	if (kpiMetrics.length) {
		var cardsPerRow = Math.min(kpiMetrics.length, 4);
		var cardW = Math.floor((availW - gap * (cardsPerRow - 1)) / cardsPerRow);
		var cardH = 52;
		var x = startX;
		kpiMetrics.forEach(function(metric) {
			if (x + cardW > maxX + 0.5 && x > startX) {
				x = startX;
				rowY += cardH + gap;
			}
			fn_drawSingleKpiCard(pdfDoc, metric, x, rowY, cardW, cardH);
			x += cardW + gap;
		});
		rowY += cardH + gap;
	}

	if (wheelMetrics.length) {
		var wheelsPerRow = Math.min(wheelMetrics.length, 3);
		var wheelW = Math.floor((availW - gap * (wheelsPerRow - 1)) / wheelsPerRow);
		var wheelH = 130;
		var wx = startX;
		wheelMetrics.forEach(function(metric) {
			if (wx + wheelW > maxX + 0.5 && wx > startX) {
				wx = startX;
				rowY += wheelH + gap;
			}
			fn_drawWheelCard(pdfDoc, metric, wx, rowY, wheelW, wheelH);
			wx += wheelW + gap;
		});
		rowY += wheelH + gap;
	}

	return rowY + 2;
}

export {
	CHART_OPTIONS,
	fn_normalizeReportCharts,
	fn_buildReportChartMetric,
	fn_drawReportChart,
};
